import type { PageDefinition } from '@wix/thunderbolt-becky-types'
import type { VsmContext, MasterPageConfigEntry, MasterPageConfigFn } from '@wix/thunderbolt-vsm-api'
import type { PagesSiteConfig } from '../types'
import { name } from '../symbols'

const pagesMasterPageConfig: MasterPageConfigFn<PagesSiteConfig> = ({ api }: VsmContext) => {
	const pageItems = api.components.getDataItemsByType<PageDefinition['data']>('Page')
	const appPageItems = api.components.getDataItemsByType<PageDefinition['data']>('AppPage')
	const nonPopupPages: Record<string, boolean> = {}

	for (const [id, pageData] of Object.entries(pageItems)) {
		nonPopupPages[id] = !api.page.isPopup(pageData)
	}
	for (const [id, pageData] of Object.entries(appPageItems)) {
		nonPopupPages[id] = !api.page.isPopup(pageData)
	}

	return { nonPopupPages }
}

export const masterPageConfig: MasterPageConfigEntry<PagesSiteConfig> = {
	name,
	configFactory: pagesMasterPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
